/**
 * @author    David Keson
 * @copyright Common-Link AG
 */
export default {

    /**
     * @param {string|*} value
     *
     * @returns {string}
     */
    capitalize(value) {
        if (!value && value !== 0) {
            return '';
        }

        value = value.toString();

        return value.charAt(0).toUpperCase() + value.slice(1);
    },

    /**
     * @param {string|*} value
     *
     * @returns {string}
     */
    slug(value) {
        if (!value && value !== 0) {
            return '';
        }

        value = value.toString().toLowerCase();
        value = value.replace('_', '-');
        value = value.replace(new RegExp(`[^a-z0-9\-\\s]`, 'g'), '');
        value = value.replace(new RegExp(`[\-\\s]+`, 'g'), '-');
        value = value.replace(new RegExp(`^[\-\\s]+|[\-\\s]+$`, 'g'), '');

        return value;
    }
};



// WEBPACK FOOTER //
// ./src/services/AppFilters.js